import type { AppRouterPaths } from "./types";

export const appRouterPaths: AppRouterPaths = {
  krab: {
    root: "/agents",
    item: "/agents/:id",
  },
  assistants: {
    root: "/assitant",
    item: "/assitant/:id",
  },
  ai_agents_extra_app: {
    root: "/extra_app",
    item: "/extra_app/:id",
  },
  ai_agents_spa: {
    root: "/applications",
    item: "/applications/:id",
  },
  "ai-cases": {
    root: "/ai-cases",
  },
  cases: {
    root: "/cases",
    item: "/cases/:id",
  },
  classify: {
    root: "/classification_model_education",
    item: "/classification_model_education/:id",
  },
  dialogs: {
    root: "/dialog",
    item: "/dialog/:id",
  },
  embeddings: {
    root: "/embedding_models",
  },
  gitfolders: {
    root: "/gitfolders",
  },
  knowledge_base: {
    root: "/knowledge_base",
    item: "/knowledge_base/:id",
  },
  llm_compare: {
    root: "/llm_compare",
    item: "/llm_compare/:id",
  },
  meetings: {
    root: "/meetings",
    item: "/meetings/:id",
  },
  practicum: {
    root: "/practicum",
    item: "/practicum/:id",
  },
  research: {
    root: "/research",
    item: "/research/:id",
  },
  polls: {
    root: "/polls",
  },
  userfiles: {
    root: "/artifacts",
    item: "/artifacts/:id",
  },
  schemas: {
    root: "/schemas",
    item: "/schemas/:id",
  },
  skills: {
    root: "/skills",
    item: "/skills/:id",
  },
  stylizator: {
    root: "/stylizator",
    item: "/stylizator/:id",
  },
  ai_agents_telegram_bots: {
    root: "/telegramm_bots",
    item: "/telegramm_bots/:id",
  },
  login: {
    root: "/login",
  },
  notFound: {
    root: "*",
  },
};
